<p class="fs-6 mb-2">
    Safely's non-intrusive guest screening process helps give more peace of mind to your homeowners and
    communities. We can conduct identity checks, perform multi-state criminal and sex offender searches,
    Terrorist & Financial Crime Watchlist searches, and review our own proprietary rental database.
</p>
<p class="fs-6 mb-2">
    Should you inform us you would like to deny a reservation based on the information provided in the
    screening, at your direction we will send written documentation to the guest in compliance with the Fair
    Credit Reporting Act (FCRA).
</p>
<p class="fs-6 mb-2">
    Limitations of screening:
</p>
<ul class="ms-4 mb-2 list-style">
    <li>
        Criminal checks are limited to convictions within 7 years that are felonies or violent or
        financially related misdemeanors.
    </li>
    <li>
        Checks may be limited based on applicable laws of the country of origin or citizenship.
    </li>
    <li>
        Guest screening features vary by customer and account setup. You can confirm which features you have
        available by checking your screening package selections in the Organization tab.
    </li>
    <li>
        Completion of checks is dependent upon Safely's receipt of the guest data required to complete
        those checks. If this data is not received for the guest, the check will be represented with a
        gray circle, indicating “Guest Data not Provided/Submitted”.
    </li>
</ul>

<p class="fs-6 mb-3">
    For best results, consider using a driver's license or government-issued identification before
    submitting this form.
</p>
<p class="fs-12 mb-3 questions-text">
    <span>Have questions? Email </span><span class="email-text">concierge&#64;safely.com</span>
</p>